import React from "react";
import AdtopiaLoadLP from "../../../Utility/AdtopiaLoadLP.js";
import FormVAQ_UB_4_3_1_B from "../../Forms/FormVAQ_UB_4_3_1_B.js";
import Footer from "../../Includes/Layouts/VAQ_UB_4_3/Footer.js";
import FbViewPixel from "../../../Utility/FbViewPixel.js";
import "../../../assets/VAQ_UB_4_3_1_B/scss/VAQ_UB_4_3_1_B.scss";
import AccordSection from "../../Includes/Layouts/VAQ_UB_4_3/AccordSection.js";

const VAQ_UB_4_3_1_B = () => {
  return (
    <>
      <AdtopiaLoadLP pageType="LP" splitName="VAQ_UB_4_3_1_B" />
      <FbViewPixel />
      <div className="VAQ_UB_4_3_1_B">
        <FormVAQ_UB_4_3_1_B />
        <AccordSection />
        <Footer />
      </div>
    </>
  );
};

export default VAQ_UB_4_3_1_B;
